module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_3.3d1cb75b.png";